import {
  createStyles,
  Divider,
  Link,
  makeStyles,
  Typography,
} from "@material-ui/core"
import { colors } from "../../utils/theme"
import { PrimaryButton } from "../atoms/button/Button"
import Logo from "../atoms/Logo"
import { TitledCard } from "../molecules/titledCard/TitledCard"
import { BaseTemplate } from "../templates/BaseTemplate"

const useStyles = makeStyles((theme) =>
  createStyles({
    register: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      height: "100vh",
      backgroundColor: colors.primary.cloud,
      alignItems: "center",
      justifyContent: "center",
    },
    button: {
      width: "100%",
    },
    marginBottom16: {
      marginBottom: theme.spacing(2),
    },
    marginBottom8: {
      marginBottom: theme.spacing(1),
    },
    card: {
      width: 440,
      "& [class^=makeStyles-card-]": {
        width: "440px !important",
      },
    },
    registerContainer: {
      display: "flex",
      alignItems: "center",
      alignSelf: "center",
      marginBottom: theme.spacing(2),
    },
    logo: {
      position: "absolute",
      top: theme.spacing(6),
      left: theme.spacing(6),
    },
    center: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    input: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
    login: {
      color: colors.neutral.asphalt,
      marginRight: 4,
    },
    subtitle: {
      fontWeight: 400,
      color: colors.neutral.denim,
      marginBottom: theme.spacing(4),
    },
    inputContainer: {
      position: "relative",
      width: "100%",
    },
    marginBottom32: {
      marginBottom: theme.spacing(4),
    },
    denim: {
      color: colors.neutral.denim,
    },
    marginLink: {
      margin: theme.spacing(0.5),
    },
    periwinkle: {
      color: colors.primary.periwinkle,
    },
    btnContainer: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
      marginBottom: theme.spacing(2),
    },
    white: {
      color: colors.neutral.white,
    },
    btn: {
      width: "48%",
      fontSize: "medium",
    },
    nextSteps: {
      marginBottom: theme.spacing(2),
      textAlign: "center",
    },
  })
)

const ClientInvitationSuccess = () => {
  const classes = useStyles()

  return (
    <>
      <BaseTemplate>
        <div>
          <Logo className={classes.logo} />
          <div className={classes.card}>
            <TitledCard title="Your account is all set!">
              <Typography variant="body1" className={classes.subtitle}>
                Your Vira account is now connected to your care team. They'll be
                able to see your progress and offer support when you need it.
                You may also receive gentle reminders and assessments to help
                you on your journey.
              </Typography>
              <div className={classes.nextSteps}>
                <Typography variant="h2">What's next?</Typography>
              </div>
              <div className={classes.nextSteps}>
                <Typography variant="body1">
                  You're ready to download the Vira app.
                </Typography>
              </div>
              <div className={classes.btnContainer}>
                <PrimaryButton className={classes.btn}>
                  <Link
                    href="https://apps.apple.com/us/app/vira-by-ksana-health/id1622715111"
                    target="_blank"
                    rel="noreferrer"
                    className={classes.white}
                  >
                    Apple App Store
                  </Link>
                </PrimaryButton>
                <PrimaryButton className={classes.btn}>
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.ksana.vira&hl=en_US"
                    target="_blank"
                    rel="noreferrer"
                    className={classes.white}
                  >
                    Google Play Store
                  </Link>
                </PrimaryButton>
              </div>
              <Divider className={classes.marginBottom16} />
              <div className={classes.registerContainer}>
                <Typography variant="h4" className={classes.login}>
                  Helpful Resources
                </Typography>
              </div>
              <div className={classes.marginLink}>
                <Link
                  href="https://externalpartnershare.blob.core.windows.net/public-assets/Vira_Summary.mp4"
                  rel="noreferrer"
                  target="_blank"
                  className={classes.periwinkle}
                  variant="body1"
                >
                  Getting Started Guide
                </Link>
              </div>
              <div className={classes.marginLink}>
                <Link
                  href="https://externalpartnershare.blob.core.windows.net/public-assets/ViraApp_FAQ.pdf"
                  rel="noreferrer"
                  target="_blank"
                  className={classes.periwinkle}
                  variant="body1"
                >
                  Frequently Asked Questions (FAQ)
                </Link>
              </div>
              <div className={classes.marginLink}>
                <Link
                  href="mailto:support@ksanahealth.com"
                  rel="noreferrer"
                  target="_blank"
                  className={classes.periwinkle}
                  variant="body1"
                >
                  Contact Support
                </Link>
              </div>
            </TitledCard>
          </div>
        </div>
      </BaseTemplate>
    </>
  )
}

export default ClientInvitationSuccess
